// src/utils/loadKakaoMap.ts
const KAKAO_API_KEY = process.env.REACT_APP_KAKAO_API_KEY;
export const loadKakaoMapScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined') return;

    if (window.kakao && window.kakao.maps) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${KAKAO_API_KEY}&libraries=services,clusterer,drawing`;
    script.async = true;
    script.onload = () => {
      resolve();
    };
    script.onerror = () => reject('카카오 스크립트 로딩 실패');
    document.head.appendChild(script);
  });
};